export default __webpack_public_path__ + "static/media/epub.7a8df611.png";